/**
 * Internal tool: only Foresight super admins (Clerk `publicMetadata.admin`)
 * can open the midterm tracker. Clients never see the tab.
 */
export const canAccessMidterms = (
  user:
    { id: string; publicMetadata?: Record<string, unknown> } | null | undefined
): boolean => !!user && user.publicMetadata?.admin === true;
